<section
  *transloco="let t"
  class="auth-intro-container"
  [class.error]="submitted && !loading && failed"
  [class.ios-app]="redirect$ | async"
  [class.dialog]="inDialog"
  [class.small-mobileL]="(lessThan$ | async)?.mobileL"
  [class.small-xs]="(lessThan$ | async)?.xs">
  <nav class="dialog-head" *ngIf="inDialog">
    <div aria-hidden="true" class="dynamic-space"></div>
    <button type="button" class="button popsy-button-icon small" (click)="close(true)">
      <popsy-icon-remove class="icon gray-dark"></popsy-icon-remove>
    </button>
  </nav>
  <div class="form">
    <app-email-phone-sign-in
      class="full-width"
      (submitting)="onEmailPhoneSubmitting($event)"
      (handleRedirect)="onHandleRedirect()"
      (closeDialog)="close(true)"></app-email-phone-sign-in>

    @if (!submitted) {
      <span class="fixed-space-24" aria-hidden="true"></span>
      <span class="margin-auto"> {{ t('hint_or') }} </span>
      <span class="fixed-space-8" aria-hidden="true"></span>

      <!-- Sign with Google -->
      <ng-container>
        <span class="fixed-space-16" aria-hidden="true"></span>
        <button
          type="button"
          class="google social-button"
          [disabled]="loading"
          (click)="onSignWithGoogle()">
          <div class="icon-container" [class.rtl]="isRtlLayout$ | async">
            <popsy-icon-google class="icon"></popsy-icon-google>
          </div>
          <!-- button text -->
          <span class="message">{{ t('action_continue_with_google') }}</span>
        </button>
      </ng-container>

      <!-- Sign with Apple -->
      <ng-container>
        <span class="fixed-space-16" aria-hidden="true"></span>
        <button
          type="button"
          class="apple social-button"
          [disabled]="loading"
          (click)="onSignWithApple()">
          <div class="icon-container">
            <popsy-icon-apple class="icon"></popsy-icon-apple>
          </div>
          <!-- button text -->
          <span class="message">{{ t('action_continue_with_apple') }}</span>
        </button>
      </ng-container>

      <span class="fixed-space-24" aria-hidden="true"></span>
      <div class="flex align-center">
        <popsy-checkbox
          [checked]="shouldSubscribe()"
          (valueChange)="shouldSubscribe.set(!shouldSubscribe())"></popsy-checkbox>

        @if (lang === 'en') {
          <span class="text-gray-05 small">
            Keep me posted with exclusive offers and discounts.
          </span>
        } @else {
          <span class="text-gray-05 small">
            ابق على اطلاع بالعروض الحصرية والخصومات.
          </span>
        }
      </div>
    }

    <span class="fixed-space-32" aria-hidden="true"></span>
  </div>
</section>
